import { gql } from 'apollo-boost';
import { FOLDER_CACHE_SAFE_FIELDS } from '../../fragments/folder/cache-safe-folder-fields';

export const GET_SHARED_FOLDERS = gql`
    query getSharedFolders {
        getSharedFolders {
            linkRole
            role
            sharedAt
            folder {
                ...FolderCacheSafeFields
            }
            owner {
                id
                email
                fullName
            }
        }
    }
    ${FOLDER_CACHE_SAFE_FIELDS}
`;